module.exports = __webpack_public_path__ + "img/btn-faq@3x.87388612.jpg";